/**
 * Smooth Scroll Script
 * Provides smooth scroll to sections when clicking navigation links
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    headerHeight: 80, // Fixed header height
    scrollDuration: 800, // Animation duration in ms
    easingFunction: 'easeInOutCubic'
  };

  // Easing functions
  const easingFunctions = {
    linear: function(t) {
      return t;
    },
    easeInOutQuad: function(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInOutCubic: function(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }
  };

  /**
   * Smooth scroll to target element
   */
  function smoothScrollTo(targetElement, duration) {
    const startPosition = window.pageYOffset;
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - CONFIG.headerHeight;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easingFunctions[CONFIG.easingFunction](progress);
      
      window.scrollTo(0, startPosition + distance * ease);
      
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }

  /**
   * Activate/deactivate class for navigation links
   */
  function updateActiveLink(targetId) {
    const navLinks = document.querySelectorAll('.header__link');
    navLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href === `#${targetId}`) {
        link.classList.add('header__link--active');
      } else {
        link.classList.remove('header__link--active');
      }
    });
  }

  /**
   * Track scroll position and highlight active section
   */
  function highlightActiveSection() {
    const sections = document.querySelectorAll('section[id]');
    const scrollPosition = window.pageYOffset + CONFIG.headerHeight + 100;

    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const sectionId = section.getAttribute('id');

      if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
        updateActiveLink(sectionId);
      }
    });
  }

  /**
   * Handle link click
   */
  function handleLinkClick(event) {
    const link = event.currentTarget;
    const targetId = link.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      event.preventDefault();
      
      // Update URL without scrolling
      history.pushState(null, null, `#${targetId}`);
      
      // Smooth scroll
      smoothScrollTo(targetElement, CONFIG.scrollDuration);
      
      // Update active link
      updateActiveLink(targetId);
    }
  }

  /**
   * Change header appearance on scroll
   */
  function handleHeaderScroll() {
    const header = document.getElementById('header');
    if (window.pageYOffset > 100) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
  }

  /**
   * Initialization
   */
  function init() {
    // Attach event listeners to navigation links
    const navLinks = document.querySelectorAll('a[href^="#"]');
    navLinks.forEach(link => {
      link.addEventListener('click', handleLinkClick);
    });

    // Track scroll for highlighting active section
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      handleHeaderScroll();
      
      // Debounce for optimization
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        highlightActiveSection();
      }, 100);
    }, { passive: true });

    // Scroll to correct section on page load with #hash
    window.addEventListener('load', () => {
      const hash = window.location.hash;
      if (hash) {
        const targetElement = document.querySelector(hash);
        if (targetElement) {
          setTimeout(() => {
            smoothScrollTo(targetElement, CONFIG.scrollDuration);
          }, 100);
        }
      }
      highlightActiveSection();
    });
  }

  // Run after DOM loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
